import { useSearchParams } from 'react-router-dom';
import { SecretScope } from '@optidev/shared-types';
import SecretsManager from '@/components/secrets/SecretsManager';

export default function Secrets() {
  const [searchParams] = useSearchParams();
  const projectIdFromUrl = searchParams.get('projectId');

  return (
    <div className="min-h-full">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14 lg:py-16">
        <SecretsManager
          scope={projectIdFromUrl ? SecretScope.PROJECT : undefined}
          projectId={projectIdFromUrl || undefined}
          showScopeTabs={true}
          lockToProject={false}
          compact={true}
          className="max-w-full"
        />
      </div>
    </div>
  );
}
